import { PriceList, Stake, Token } from '@jdiyield/interfaces'
import BigNumber from 'bignumber.js'
import Web3 from 'web3'

import { calculate } from '../calculate'
import { getBalanceNumber } from '../helper'
import getNodeUrl from '../rpcRandom'
import { StakeFunc, StakeProps } from '../types'
import { safeGasEstimates } from '../utils'

const BSCDashBoardAbi = [
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'previousOwner', type: 'address' },
      { indexed: true, internalType: 'address', name: 'newOwner', type: 'address' }
    ],
    name: 'OwnershipTransferred',
    type: 'event'
  },
  {
    inputs: [],
    name: 'BUNNY',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'CAKE',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'VaultCakeToCake',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'WBNB',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: 'pool', type: 'address' },
      { internalType: 'address', name: 'account', type: 'address' }
    ],
    name: 'calculateProfit',
    outputs: [
      { internalType: 'uint256', name: 'profit', type: 'uint256' },
      { internalType: 'uint256', name: 'profitInBNB', type: 'uint256' }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: 'pool', type: 'address' },
      { internalType: 'address', name: 'account', type: 'address' }
    ],
    name: 'infoOfPool',
    outputs: [
      {
        components: [
          { internalType: 'address', name: 'pool', type: 'address' },
          { internalType: 'uint256', name: 'balance', type: 'uint256' },
          { internalType: 'uint256', name: 'principal', type: 'uint256' },
          { internalType: 'uint256', name: 'available', type: 'uint256' },
          { internalType: 'uint256', name: 'tvl', type: 'uint256' },
          { internalType: 'uint256', name: 'utilized', type: 'uint256' },
          { internalType: 'uint256', name: 'liquidity', type: 'uint256' },
          { internalType: 'uint256', name: 'pBASE', type: 'uint256' },
          { internalType: 'uint256', name: 'pBUNNY', type: 'uint256' },
          { internalType: 'uint256', name: 'depositedAt', type: 'uint256' },
          { internalType: 'uint256', name: 'feeDuration', type: 'uint256' },
          { internalType: 'uint256', name: 'feePercentage', type: 'uint256' },
          { internalType: 'uint256', name: 'portfolio', type: 'uint256' }
        ],
        internalType: 'struct PoolConstant.PoolInfo',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: 'pool', type: 'address' },
      { internalType: 'address', name: 'account', type: 'address' }
    ],
    name: 'infoOfRelay',
    outputs: [
      {
        components: [
          { internalType: 'address', name: 'pool', type: 'address' },
          { internalType: 'uint256', name: 'balanceInUSD', type: 'uint256' },
          { internalType: 'uint256', name: 'debtInUSD', type: 'uint256' }
        ],
        internalType: 'struct PoolConstant.RelayInfo',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  { inputs: [], name: 'initialize', outputs: [], stateMutability: 'nonpayable', type: 'function' },
  {
    inputs: [],
    name: 'owner',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: '', type: 'address' }],
    name: 'pancakePoolIds',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: '', type: 'address' }],
    name: 'perfExemptions',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: 'pool', type: 'address' }],
    name: 'poolTypeOf',
    outputs: [{ internalType: 'enum PoolConstant.PoolTypes', name: '', type: 'uint8' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: '', type: 'address' }],
    name: 'poolTypes',
    outputs: [{ internalType: 'enum PoolConstant.PoolTypes', name: '', type: 'uint8' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: 'account', type: 'address' },
      { internalType: 'address[]', name: 'pools', type: 'address[]' }
    ],
    name: 'poolsOf',
    outputs: [
      {
        components: [
          { internalType: 'address', name: 'pool', type: 'address' },
          { internalType: 'uint256', name: 'balance', type: 'uint256' },
          { internalType: 'uint256', name: 'principal', type: 'uint256' },
          { internalType: 'uint256', name: 'available', type: 'uint256' },
          { internalType: 'uint256', name: 'tvl', type: 'uint256' },
          { internalType: 'uint256', name: 'utilized', type: 'uint256' },
          { internalType: 'uint256', name: 'liquidity', type: 'uint256' },
          { internalType: 'uint256', name: 'pBASE', type: 'uint256' },
          { internalType: 'uint256', name: 'pBUNNY', type: 'uint256' },
          { internalType: 'uint256', name: 'depositedAt', type: 'uint256' },
          { internalType: 'uint256', name: 'feeDuration', type: 'uint256' },
          { internalType: 'uint256', name: 'feePercentage', type: 'uint256' },
          { internalType: 'uint256', name: 'portfolio', type: 'uint256' }
        ],
        internalType: 'struct PoolConstant.PoolInfo[]',
        name: '',
        type: 'tuple[]'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: 'account', type: 'address' },
      { internalType: 'address[]', name: 'pools', type: 'address[]' }
    ],
    name: 'portfolioOf',
    outputs: [{ internalType: 'uint256', name: 'deposits', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'priceCalculator',
    outputs: [{ internalType: 'contract PriceCalculatorBSC', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: 'pool', type: 'address' },
      { internalType: 'address', name: 'account', type: 'address' }
    ],
    name: 'profitOfPool',
    outputs: [
      { internalType: 'uint256', name: 'profit', type: 'uint256' },
      { internalType: 'uint256', name: 'bunny', type: 'uint256' }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: 'account', type: 'address' },
      { internalType: 'address[]', name: 'pools', type: 'address[]' }
    ],
    name: 'relaysOf',
    outputs: [
      {
        components: [
          { internalType: 'address', name: 'pool', type: 'address' },
          { internalType: 'uint256', name: 'balanceInUSD', type: 'uint256' },
          { internalType: 'uint256', name: 'debtInUSD', type: 'uint256' }
        ],
        internalType: 'struct PoolConstant.RelayInfo[]',
        name: '',
        type: 'tuple[]'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  { inputs: [], name: 'renounceOwnership', outputs: [], stateMutability: 'nonpayable', type: 'function' },
  {
    inputs: [
      { internalType: 'address', name: 'pool', type: 'address' },
      { internalType: 'uint256', name: 'pid', type: 'uint256' }
    ],
    name: 'setPancakePoolId',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: 'pool', type: 'address' },
      { internalType: 'bool', name: 'exemption', type: 'bool' }
    ],
    name: 'setPerfExemption',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: 'pool', type: 'address' },
      { internalType: 'enum PoolConstant.PoolTypes', name: 'poolType', type: 'uint8' }
    ],
    name: 'setPoolType',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: 'newOwner', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: 'pool', type: 'address' }],
    name: 'tvlOfPool',
    outputs: [{ internalType: 'uint256', name: 'tvl', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: 'pool', type: 'address' }],
    name: 'utilizationOfPool',
    outputs: [
      { internalType: 'uint256', name: 'liquidity', type: 'uint256' },
      { internalType: 'uint256', name: 'utilized', type: 'uint256' }
    ],
    stateMutability: 'view',
    type: 'function'
  }
]

const VaultAbi = [
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'user', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'profit', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'performanceFee', type: 'uint256' }
    ],
    name: 'BunnyPaid',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'user', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'amount', type: 'uint256' }
    ],
    name: 'Deposited',
    type: 'event'
  },
  { anonymous: false, inputs: [], name: 'DisableWhitelist', type: 'event' },
  { anonymous: false, inputs: [], name: 'EnableWhitelist', type: 'event' },
  {
    anonymous: false,
    inputs: [{ indexed: false, internalType: 'uint256', name: 'profit', type: 'uint256' }],
    name: 'Harvested',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'previousOwner', type: 'address' },
      { indexed: true, internalType: 'address', name: 'newOwner', type: 'address' }
    ],
    name: 'OwnershipTransferred',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, internalType: 'bool', name: 'isPaused', type: 'bool' }],
    name: 'PauseChanged',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'user', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'profit', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'performanceFee', type: 'uint256' }
    ],
    name: 'ProfitPaid',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: 'address', name: 'token', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'amount', type: 'uint256' }
    ],
    name: 'Recovered',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: '_address', type: 'address' },
      { indexed: false, internalType: 'bool', name: 'whitelist', type: 'bool' }
    ],
    name: 'Whitelisted',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'user', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'amount', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'withdrawalFee', type: 'uint256' }
    ],
    name: 'Withdrawn',
    type: 'event'
  },
  {
    inputs: [],
    name: 'balance',
    outputs: [{ internalType: 'uint256', name: 'amount', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'bunnyChef',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'uint256', name: '_amount', type: 'uint256' }],
    name: 'deposit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  { inputs: [], name: 'depositAll', outputs: [], stateMutability: 'nonpayable', type: 'function' },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'depositedAt',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'bool', name: 'disable', type: 'bool' }],
    name: 'disableWhitelist',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'earned',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  { inputs: [], name: 'getReward', outputs: [], stateMutability: 'nonpayable', type: 'function' },
  { inputs: [], name: 'harvest', outputs: [], stateMutability: 'nonpayable', type: 'function' },
  { inputs: [], name: 'initialize', outputs: [], stateMutability: 'nonpayable', type: 'function' },
  {
    inputs: [{ internalType: 'address', name: '_address', type: 'address' }],
    name: 'isWhitelist',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'keeper',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'lastPauseTime',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'minter',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'paused',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'pid',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'poolType',
    outputs: [{ internalType: 'enum PoolConstant.PoolTypes', name: '', type: 'uint8' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'priceShare',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'principalOf',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: '_token', type: 'address' },
      { internalType: 'uint256', name: 'amount', type: 'uint256' }
    ],
    name: 'recoverToken',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  { inputs: [], name: 'renounceOwnership', outputs: [], stateMutability: 'nonpayable', type: 'function' },
  {
    inputs: [],
    name: 'rewardsToken',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'contract IBunnyChef', name: 'newBunnyChef', type: 'address' }],
    name: 'setBunnyChef',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: '_keeper', type: 'address' }],
    name: 'setKeeper',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: 'newMinter', type: 'address' }],
    name: 'setMinter',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'bool', name: '_paused', type: 'bool' }],
    name: 'setPaused',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: '_address', type: 'address' },
      { internalType: 'bool', name: '_on', type: 'bool' }
    ],
    name: 'setWhitelist',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'sharesOf',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'stakingToken',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'totalShares',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: 'newOwner', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'uint256', name: 'shares', type: 'uint256' }],
    name: 'withdraw',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  { inputs: [], name: 'withdrawAll', outputs: [], stateMutability: 'nonpayable', type: 'function' },
  {
    inputs: [{ internalType: 'uint256', name: '_amount', type: 'uint256' }],
    name: 'withdrawUnderlying',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'withdrawableBalanceOf',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  }
]

const BunnyWBNBAbi = [
  {
    inputs: [],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'OwnershipTransferred',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'bool',
        name: 'isPaused',
        type: 'bool'
      }
    ],
    name: 'PauseChanged',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'token',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'Recovered',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'reward',
        type: 'uint256'
      }
    ],
    name: 'RewardAdded',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'user',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'reward',
        type: 'uint256'
      }
    ],
    name: 'RewardPaid',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'newDuration',
        type: 'uint256'
      }
    ],
    name: 'RewardsDurationUpdated',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'user',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'Staked',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'user',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'Withdrawn',
    type: 'event'
  },
  {
    inputs: [],
    name: 'apy',
    outputs: [
      {
        internalType: 'uint256',
        name: '_usd',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_bunny',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_bnb',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'balance',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      }
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'deposit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'depositAll',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      }
    ],
    name: 'earned',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getReward',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getRewardForDuration',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'harvest',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'helper',
    outputs: [
      {
        internalType: 'contract IStrategyHelper',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      }
    ],
    name: 'info',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'balance',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'principal',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'available',
            type: 'uint256'
          },
          {
            components: [
              {
                internalType: 'uint256',
                name: 'usd',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'bunny',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'bnb',
                type: 'uint256'
              }
            ],
            internalType: 'struct Profit',
            name: 'profit',
            type: 'tuple'
          },
          {
            internalType: 'uint256',
            name: 'poolTVL',
            type: 'uint256'
          },
          {
            components: [
              {
                internalType: 'uint256',
                name: 'usd',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'bunny',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'bnb',
                type: 'uint256'
              }
            ],
            internalType: 'struct APY',
            name: 'poolAPY',
            type: 'tuple'
          }
        ],
        internalType: 'struct UserInfo',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'lastPauseTime',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'lastTimeRewardApplicable',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'lastUpdateTime',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'reward',
        type: 'uint256'
      }
    ],
    name: 'notifyRewardAmount',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'paused',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'periodFinish',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      }
    ],
    name: 'presaleBalanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      }
    ],
    name: 'principalOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      }
    ],
    name: 'profitOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '_usd',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_bunny',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_bnb',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'tokenAddress',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'tokenAmount',
        type: 'uint256'
      }
    ],
    name: 'recoverBEP20',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'rewardPerToken',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'rewardPerTokenStored',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'rewardRate',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    name: 'rewards',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'rewardsDistribution',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'rewardsDuration',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'rewardsToken',
    outputs: [
      {
        internalType: 'contract IBEP20',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'contract IStrategyHelper',
        name: '_helper',
        type: 'address'
      }
    ],
    name: 'setHelper',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'bool',
        name: '_paused',
        type: 'bool'
      }
    ],
    name: 'setPaused',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_rewardsDistribution',
        type: 'address'
      }
    ],
    name: 'setRewardsDistribution',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_rewardsDuration',
        type: 'uint256'
      }
    ],
    name: 'setRewardsDuration',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_rewardsToken',
        type: 'address'
      }
    ],
    name: 'setRewardsToken',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_address',
        type: 'address'
      },
      {
        internalType: 'bool',
        name: 'permission',
        type: 'bool'
      }
    ],
    name: 'setStakePermission',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      },
      {
        internalType: 'address',
        name: '_to',
        type: 'address'
      }
    ],
    name: 'stakeTo',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'stakingToken',
    outputs: [
      {
        internalType: 'contract IBEP20',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'tvl',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    name: 'userRewardPerTokenPaid',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'withdraw',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'withdrawAll',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      }
    ],
    name: 'withdrawableBalanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  }
]

type PoolType = 'TOKEN' | 'LP'

export interface FarmConfig {
  pid: number
  lpSymbol: string
  pool: PoolType
  lpAddresses: Address
  tokenSymbol: string
  tokenAddresses: Address
  quoteTokenAdresses: Address
  multiplier?: string
  isCommunity?: boolean
  earn: string
  dual?: {
    rewardPerBlock: number
    earnLabel: string
    endBlock: number
  }
}

interface Address {
  97?: string
  56: string
}

const wbnb = {
  97: '0xae13d989dac2f0debff460ac112a837c89baa7cd',
  56: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c'
}

const farms: FarmConfig[] = [
  {
    pid: 0,
    lpSymbol: 'BUNNY',
    pool: 'TOKEN',
    lpAddresses: {
      97: '0xEDfcB78e73f7bA6aD2D829bf5D462a0924da28eD',
      56: '0xb037581cF0cE10b04C4735443d95e0C93db5d940'
    },
    tokenSymbol: 'BUNNY',
    tokenAddresses: {
      97: '0xC9849E6fdB743d08fAeE3E34dd2D1bc69EA11a51',
      56: '0xC9849E6fdB743d08fAeE3E34dd2D1bc69EA11a51'
    },
    earn: 'CAKE + BUNNY',
    quoteTokenAdresses: wbnb
  },
  {
    pid: 1,
    lpSymbol: 'BUNNY-BNB FLIP',
    pool: 'LP',
    lpAddresses: {
      56: '0xa6C29a422D1612293669156a34f2793526783622'
    },
    tokenSymbol: 'BUNNY',
    tokenAddresses: {
      56: '0x5aFEf8567414F29f0f927A0F2787b188624c10E2'
    },
    earn: 'CAKE + BUNNY',
    quoteTokenAdresses: wbnb
  },
  {
    pid: 2,
    lpSymbol: 'CAKE',
    pool: 'TOKEN',
    lpAddresses: {
      56: '0xEDfcB78e73f7bA6aD2D829bf5D462a0924da28eD'
    },
    tokenSymbol: 'BUNNY',
    earn: 'CAKE + BUNNY',
    tokenAddresses: {
      56: '0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82'
    },
    quoteTokenAdresses: wbnb
  },
  {
    pid: 3,
    lpSymbol: 'CAKE-BNB FLIP',
    pool: 'LP',
    lpAddresses: {
      56: '0xA599d6b81eC4a5DDd8eCa85e3AAc31E006aF00AA'
    },
    tokenSymbol: 'BUNNY',
    tokenAddresses: {
      56: '0x0eD7e52944161450477ee417DE9Cd3a859b14fD0'
    },
    earn: 'CAKE-BNB FLIP + BUNNY',
    quoteTokenAdresses: wbnb
  },
  {
    pid: 4,
    lpSymbol: 'CAKE-BNB FLIP CAKE Maximizer',
    pool: 'LP',
    earn: 'CAKE + BUNNY',
    lpAddresses: {
      56: '0x203Ee29ba85BbDfA23bFaE5D77620AeFDaf92cB1'
    },
    tokenSymbol: 'BUNNY',
    tokenAddresses: {
      56: '0x0eD7e52944161450477ee417DE9Cd3a859b14fD0'
    },
    quoteTokenAdresses: wbnb
  },
  {
    pid: 5,
    lpSymbol: 'BTCB-BNB FLIP',
    pool: 'LP',
    lpAddresses: {
      56: '0x285F793CE97079D4a5712E616AFBbb971Dbf1f1f'
    },
    earn: 'BTCB-BNB FLIP + BUNNY',
    tokenSymbol: 'BUNNY',
    tokenAddresses: {
      56: '0x61EB789d75A95CAa3fF50ed7E47b96c132fEc082'
    },
    quoteTokenAdresses: wbnb
  },
  {
    pid: 6,
    lpSymbol: 'BTCB-BNB FLIP CAKE Maximizer',
    pool: 'LP',
    lpAddresses: {
      56: '0xac20925e6615ad6871987e199783Fa80Bf24EB39'
    },
    tokenSymbol: 'BUNNY',
    earn: 'CAKE + BUNNY',
    tokenAddresses: {
      56: '0x61EB789d75A95CAa3fF50ed7E47b96c132fEc082'
    },
    quoteTokenAdresses: wbnb
  },
  {
    pid: 7,
    lpSymbol: 'ETH-BNB FLIP',
    pool: 'LP',
    lpAddresses: {
      56: '0x0d17e7B77C678C79C3ab5176e164FF0BCceb8EAa'
    },
    earn: 'ETH-BNB FLIP + BUNNY',
    tokenSymbol: 'BUNNY',
    tokenAddresses: {
      56: '0x74E4716E431f45807DCF19f284c7aA99F18a4fbc'
    },
    quoteTokenAdresses: wbnb
  },
  {
    pid: 8,
    lpSymbol: 'ETH-BNB FLIP CAKE Maximizer',
    pool: 'LP',
    earn: 'CAKE + BUNNY',
    lpAddresses: {
      56: '0x7D52a1697F2dF08E6fb2b5A88E0E8e4D7C11a921'
    },
    tokenSymbol: 'BUNNY',
    tokenAddresses: {
      56: '0x74E4716E431f45807DCF19f284c7aA99F18a4fbc'
    },
    quoteTokenAdresses: wbnb
  },
  {
    pid: 9,
    lpSymbol: 'BUSD-BNB FLIP CAKE Maximizer',
    pool: 'LP',
    lpAddresses: {
      56: '0x81fa6F9F4599c5316Cc53B782DE7c01EFf4f9551'
    },
    tokenSymbol: 'BUNNY',
    earn: 'CAKE + BUNNY',
    tokenAddresses: {
      56: '0x58F876857a02D6762E0101bb5C46A8c1ED44Dc16'
    },
    quoteTokenAdresses: wbnb
  },
  {
    pid: 10,
    lpSymbol: 'USDT-BNB FLIP',
    pool: 'LP',
    lpAddresses: {
      56: '0x633e538EcF0bee1a18c2EDFE10C4Da0d6E71e77B'
    },
    earn: 'USDT-BNB FLIP + BUNNY',
    tokenSymbol: 'BUNNY',
    tokenAddresses: {
      56: '0x16b9a82891338f9bA80E2D6970FddA79D1eb0daE'
    },
    quoteTokenAdresses: wbnb
  },
  {
    pid: 11,
    lpSymbol: 'USDT-BNB FLIP CAKE Maximizer',
    pool: 'LP',
    earn: 'CAKE + BUNNY',
    lpAddresses: {
      56: '0xac7D40638271D349cb2DeDfdC6268A77738403Fa'
    },
    tokenSymbol: 'BUNNY',
    tokenAddresses: {
      56: '0x16b9a82891338f9bA80E2D6970FddA79D1eb0daE'
    },
    quoteTokenAdresses: wbnb
  },
  {
    pid: 12,
    lpSymbol: 'USDT-BUSD FLIP',
    pool: 'LP',
    lpAddresses: {
      56: '0xC341c6a006cab105E8CD2518e25aaB311Cb22FF6'
    },
    earn: 'USDT-BUSD FLIP + BUNNY',
    tokenSymbol: 'BUNNY',
    tokenAddresses: {
      56: '0x7EFaEf62fDdCCa950418312c6C91Aef321375A00'
    },
    quoteTokenAdresses: wbnb
  },
  {
    pid: 13,
    lpSymbol: 'USDT-BUSD FLIP CAKE Maximizer',
    pool: 'LP',
    lpAddresses: {
      56: '0x74fdc215f8309Ec58Fd34455bf3Fee95FB3416dD'
    },
    earn: 'CAKE + BUNNY',
    tokenSymbol: 'BUNNY',
    tokenAddresses: {
      56: '0x7EFaEf62fDdCCa950418312c6C91Aef321375A00'
    },
    quoteTokenAdresses: wbnb
  },
  {
    pid: 14,
    lpSymbol: 'VAI-BUSD FLIP',
    pool: 'LP',
    lpAddresses: {
      56: '0xFdb7D4AbD0109b36667946726dF943E83570286C'
    },
    earn: 'VAI-BUSD FLIP + BUNNY',
    tokenSymbol: 'BUNNY',
    tokenAddresses: {
      56: '0x133ee93FE93320e1182923E1a640912eDE17C90C'
    },
    quoteTokenAdresses: wbnb
  },
  {
    pid: 15,
    lpSymbol: 'VAI-BUSD FLIP CAKE Maximizer',
    pool: 'LP',
    earn: 'CAKE + BUNNY',
    lpAddresses: {
      56: '0x7f0320cef62C88CE1DB7d77c1849082C053E2344'
    },
    tokenSymbol: 'BUNNY',
    tokenAddresses: {
      56: '0x133ee93FE93320e1182923E1a640912eDE17C90C'
    },
    quoteTokenAdresses: wbnb
  },
  {
    pid: 16,
    lpSymbol: 'BNB',
    pool: 'TOKEN',
    earn: 'BNB + BUNNY',
    lpAddresses: {
      56: '0x52cFa188A1468A521A98eaa798E715Fbb9eb38a3'
    },
    tokenSymbol: 'BUNNY',
    tokenAddresses: {
      56: '0xbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb'
    },
    quoteTokenAdresses: wbnb
  },
  {
    pid: 17,
    lpSymbol: 'ETH',
    pool: 'TOKEN',
    lpAddresses: {
      56: '0x22af73683dee5D266B0c36c37D0Fd62c402Fd250'
    },
    earn: 'ETH + BUNNY',
    tokenSymbol: 'BUNNY',
    tokenAddresses: {
      56: '0x2170Ed0880ac9A755fd29B2688956BD959F933F8'
    },
    quoteTokenAdresses: wbnb
  },
  {
    pid: 18,
    lpSymbol: 'BTCB',
    pool: 'TOKEN',
    earn: 'BTCB + BUNNY',
    lpAddresses: {
      56: '0x549d2e2B4fA19179CA5020A981600571C2954F6a'
    },
    tokenSymbol: 'BUNNY',
    tokenAddresses: {
      56: '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c'
    },
    quoteTokenAdresses: wbnb
  },
  {
    pid: 19,
    lpSymbol: 'USDT',
    pool: 'TOKEN',
    lpAddresses: {
      56: '0x0Ba950F0f099229828c10a9B307280a450133FFc'
    },
    earn: 'USDT + BUNNY',
    tokenSymbol: 'BUNNY',
    tokenAddresses: {
      56: '0x55d398326f99059fF775485246999027B3197955'
    },
    quoteTokenAdresses: wbnb
  },
  {
    pid: 20,
    lpSymbol: 'BUSD',
    pool: 'TOKEN',
    lpAddresses: {
      56: '0x0243A20B20ECa78ddEDF6b8ddb43a0286438A67A'
    },
    earn: 'BUSD + BUNNY',
    tokenSymbol: 'BUNNY',
    tokenAddresses: {
      56: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56'
    },
    quoteTokenAdresses: wbnb
  },
  {
    pid: 21,
    lpSymbol: 'BUNNY',
    pool: 'TOKEN',
    lpAddresses: {
      56: '0xCADc8CB26c8C7cB46500E61171b5F27e9bd7889D'
    },
    earn: 'WBNB',
    tokenSymbol: 'BUNNY',
    tokenAddresses: {
      56: '0xc9849e6fdb743d08faee3e34dd2d1bc69ea11a51'
    },
    quoteTokenAdresses: wbnb
  },
  {
    pid: 22,
    lpSymbol: 'BUNNY',
    pool: 'TOKEN',
    lpAddresses: {
      56: '0xC004a3b5Af216e9c2c59a9EA8BC3Ee07aF667329'
    },
    earn: 'BUNNY',
    tokenSymbol: 'BUNNY',
    tokenAddresses: {
      56: '0xc9849e6fdb743d08faee3e34dd2d1bc69ea11a51'
    },
    quoteTokenAdresses: wbnb
  }
]

const bunnyChefAddress = '0xb3c96d3c3d643c2318e4cdd0a9a48af53131f5f4'
const routerAddress = '0x10ed43c718714eb63d5aa57b78b54704e256024e'
// const BunnyDashboard = '0x59a5f2e3ebc4e47d482d6542244f5398fa8ce8d3'

export const getFarmsPancakeBunny = async (
  web3: Web3,
  walletAddress: string,
  tokens: Token[],
  priceList: PriceList
): Promise<Stake[]> => {
  try {
    const myAccount = walletAddress
    const lookPrice = priceList
    const ct = new web3.eth.Contract(BSCDashBoardAbi as any, bunnyChefAddress)
    // const price = lookPrice[jdi].usd
    const result = await Promise.all<Stake>(
      farms.map(async (item) => {
        try {
          const poolsOfCalls = await ct.methods.poolsOf(myAccount, [`${item.lpAddresses[56]}`]).call()
          const poolsOf = {}
          if (poolsOfCalls) {
            poolsOfCalls.forEach((p) => {
              poolsOf[p.pool.toLowerCase()] = p
            })
          }
          const balance = poolsOf[item.lpAddresses[56].toLowerCase()].balance
          if (!balance || balance == '0') {
            return null
          }

          // const availableBalanceOf = await balanceOf(walletAddress, item.tokenAddresses[56].toLowerCase())

          const deposit = await calculate(
            web3,
            {
              pool: item.pid,
              lpAddress: item.tokenAddresses[56],
              balance: balance.toString(),
              availableBalanceOf: '0',
              rewardAddress: item.quoteTokenAdresses[56]
            },
            routerAddress,
            tokens,
            priceList
          )

          if (['0xCADc8CB26c8C7cB46500E61171b5F27e9bd7889D'].includes(item.lpAddresses[56])) {
            const ct = new web3.eth.Contract(BunnyWBNBAbi as any, item.lpAddresses[56])
            const info = await ct.methods.info(walletAddress).call()
            const balance = getBalanceNumber(new BigNumber(info.balance))
            const reward = +getBalanceNumber(new BigNumber(info.profit.bnb))
            const rewardUSD = reward * lookPrice['0xbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb'].usd

            const result = {
              ...deposit,
              pool: item.pid,
              balance,
              lpAddress: item.tokenAddresses[56],
              availableBalanceOf: balance,
              poolName: item.lpSymbol,
              reward,
              rewardSymbol: 'WBNB',
              rewardUSD,
              pendingReward: 'pending',
              routerAddress: '0x05fF2B0DB69458A0750badebc4f9e13aDd608C7F',
              contractAddress: '0x1b6e3d394f1d809769407dea84711cf57e507b99',
              showReward: true,
              rewardAddress: '0xc9849e6fdb743d08faee3e34dd2d1bc69ea11a51',
              stake: true,
              unstake: true,
              removeLiquidity: 'NORMAL',
              harvest: true,
              supportIL: true,
              supportROI: false
            } as Stake
            return result
          }

          //   let pendingUSD
          //   let pendingBNB
          let pendingBUNNY
          let pendingCAKE
          if (balance) {
            const { pBUNNY, pBASE } = poolsOf[item.lpAddresses[56].toLowerCase()]
            pendingBUNNY = pBUNNY.toString()
            pendingCAKE = pBASE.toString()
          }

          const rewardUSD =
            (pendingBUNNY.toString() / 1e18) * lookPrice['0xc9849e6fdb743d08faee3e34dd2d1bc69ea11a51'].usd +
            (pendingCAKE.toString() / 1e18) * lookPrice['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'].usd

          // console.log('poolsOf[item.lpAddresses[56].toLowerCase()]', poolsOf[item.lpAddresses[56].toLowerCase()])
          // console.log('deposit', deposit)
          // console.log('reward', rewardUSD)
          // console.log('poolsOf', poolsOf[item.lpAddresses[56].toLowerCase()].balance)
          //   const rewardAmount = await ct.methods.earned(myAccount).call()

          return {
            ...deposit,
            pool: item.pid,
            balance: new BigNumber(balance).dividedBy(1e18).toString(),
            lpAddress: item.tokenAddresses[56],
            // availableBalanceOf: new BigNumber(availableBalanceOf).dividedBy(1e18).toString(),
            availableBalanceOf: '0',
            poolName: item.lpSymbol,
            reward: pendingBUNNY / 1e18, /// TO DO: Implement
            rewardSymbol: 'BUNNY', /// TO DO: Implement
            rewardUSD: rewardUSD,
            pendingReward: 'pending',
            routerAddress: '0x05fF2B0DB69458A0750badebc4f9e13aDd608C7F',
            contractAddress: '0x1b6e3d394f1d809769407dea84711cf57e507b99',
            showReward: true,
            rewardAddress: '0xc9849e6fdb743d08faee3e34dd2d1bc69ea11a51',
            stake: true,
            unstake: true,
            removeLiquidity: 'NORMAL',
            harvest: true,
            supportIL: true,
            supportROI: false
          }
        } catch (e) {
          return null
        }
      })
    )
    return result.filter((i) => i !== null)
  } catch (e) {
    return []
  }
}

const findFarmByID = (pool: number) => farms.find((i) => i.pid === pool)

export const stakeBunny: StakeFunc = async ({ web3, pool, walletAddress, amount }) => {
  try {
    const farm = findFarmByID(pool)
    const ct = new web3.eth.Contract(VaultAbi as any, farm.lpAddresses[56])
    const contractWithMethod = ct.methods.deposit(new BigNumber(amount).times(new BigNumber(10).pow(18)).toFixed())
    const gasLimit = await safeGasEstimates({ contractWithMethod, walletAddress })

    await contractWithMethod.send({ from: walletAddress, gas: gasLimit })
  } catch (e) {
    return false
  }
}

export const unStakeBunny: StakeFunc = async ({ web3, pool, walletAddress, amount }) => {
  try {
    const farm = findFarmByID(pool)
    const ct = new web3.eth.Contract(VaultAbi as any, farm.lpAddresses[56])
    const contractWithMethod = ct.methods.withdrawUnderlying(
      new BigNumber(amount).times(new BigNumber(10).pow(18)).toFixed()
    )
    const gasLimit = await safeGasEstimates({ contractWithMethod, walletAddress })

    await contractWithMethod.send({ from: walletAddress, gas: gasLimit })

    return true
  } catch (e) {
    return false
  }
}

export const getRewardBunny: StakeFunc<Omit<StakeProps, 'amount'>> = async ({ web3, pool, walletAddress }) => {
  try {
    const farm = findFarmByID(pool)
    const ct = new web3.eth.Contract(VaultAbi as any, farm.lpAddresses[56])
    const contractWithMethod = ct.methods.getReward()
    const gasLimit = await safeGasEstimates({ contractWithMethod, walletAddress })

    await contractWithMethod.send({ from: walletAddress, gas: gasLimit })

    return true
  } catch (e) {
    return false
  }
}
